import searchOpener from "./components/searchOpener";
import searchDropCloseMobile from "./components/searchDropCloseMobile";
import menuOpener from "./components/menuOpener";
import slidingMenu from "./components/slidingMenu";
import initDialogs from "./components/initDialogs";
import indexCart from "../cart/indexCart";
import quickSearchInput from "./components/quickSearchInput";
import search from "./components/search";
import moveToolsListTablet from "./components/moveToolsListTablet";
import menu from "../menu/menu";
import headerScrollControl from "./components/headerScrollControl";
import {ValidateLogin} from "../validators/indexValidator";
import account from "../account/account";
import Logout from "../account/logout";
import windowResize from "./components/windowResize";
import toplistJs from "../toplist/toplistIndex";
import initEroticInfoBox from "./components/initEroticInfoBox";
import showCOInput from "./components/showCoInput";
import removeMenuActive from "./components/removeMenuActive";
import dropOrientation from "./components/dropOrientation";

export default function header() {
  jQuery(function () {
    menu();
    moveToolsListTablet();
    search();
    quickSearchInput();
    indexCart();
    initDialogs();
    menuOpener();
    searchDropCloseMobile();
    searchOpener();
    slidingMenu();
    headerScrollControl();
    account();
    windowResize();
    toplistJs();
    initEroticInfoBox();
    showCOInput();
    dropOrientation();
    removeMenuActive();
    initInteractionMarker();

    $('#btnLogin').on('click', function () {
      ValidateLogin($(this));
    })

    $('.loggaut').on('click', function () {
      Logout($(this));
    })
  })
  
  function initInteractionMarker() {
    if (useInteractionMarker !== 'True') {
      return;
    }
    
    const events = [
      'pointerdown',
      'mousedown',
      'touchstart',
      'keydown',
      'scroll',
      'wheel'
    ];
    
    let sent = false;
    
    const onInteract = () => {
      if (sent) {
        return;
      }
      
      sent = true;
      
      fetch('/api/CrawlerDetect/DetectInteraction', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).catch(() => {
        sent = false;
      });
      
      events.forEach(eventName => {
        window.removeEventListener(eventName, onInteract);
      });
    };
    
    events.forEach(eventName => {
      window.addEventListener(eventName, onInteract, {
        passive: true,
        once: true
      });
    });
  }
};
